module.exports = __webpack_public_path__ + "static/media/bigrams_frequency.e8f3c155.zip";